const getters = {
  scWorkLogs: state => state.sc_work_logs,
  scWorkLog: state => state.sc_work_log,
  scWorkLogFilters: state => state.sc_work_log_filters,
}

export default getters;
